import { render, staticRenderFns } from "./TaskProgress.vue?vue&type=template&id=8676511c&scoped=true&"
import script from "./TaskProgress.vue?vue&type=script&lang=js&"
export * from "./TaskProgress.vue?vue&type=script&lang=js&"
import style0 from "./TaskProgress.vue?vue&type=style&index=0&id=8676511c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8676511c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8676511c')) {
      api.createRecord('8676511c', component.options)
    } else {
      api.reload('8676511c', component.options)
    }
    module.hot.accept("./TaskProgress.vue?vue&type=template&id=8676511c&scoped=true&", function () {
      api.rerender('8676511c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/TaskProgress.vue"
export default component.exports